import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Observable, from, switchMap, catchError, of } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private localStorage: LocalStorageService, private msalService: MsalService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const loginType = this.localStorage.retrieve('login_type');
    const accessToken = this.localStorage.retrieve('access_token');
    const refreshToken = this.localStorage.retrieve('refresh_token');

    // Gunakan refresh_token untuk endpoint refresh-token
    if (request.url.includes('auth/refresh-token')) {
      if (refreshToken) {
        const authRequest = request.clone({
          setHeaders: {
            Authorization: `Bearer ${refreshToken}`
          }
        });
        return next.handle(authRequest);
      }
    } else if (accessToken) {
      // Gunakan access_token untuk endpoint lainnya
      const authRequest = request.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return next.handle(authRequest);
    }

    if (loginType !== 'form') {
      const accounts = this.msalService.instance.getAllAccounts();
      if (accounts.length > 0) {
        return from(this.msalService.acquireTokenSilent({
          scopes: [environment.msalScope],
          account: accounts[0]
        })).pipe(
          catchError((error) => {
             console.error('TokenInterceptor: SSO Token Acquisition Failed', error);
             return of(null); // Return null to indicate failure but continue stream
          }),
          switchMap((result: any) => {
            if (result) {
              const authRequest = request.clone({
                setHeaders: {
                  Authorization: `Bearer ${result.accessToken}`
                }
              });
              return next.handle(authRequest);
            }
            // Fallback: pass request without token
            return next.handle(request);
          })
        );
      }
    }

    return next.handle(request);
  }
}
